import dayjs from 'dayjs';
import ActionButton from 'lib/src/components/button/ActionButton';
import ButtonRow from 'lib/src/components/button/ButtonRow';
import LinkButton from '@components/button/LinkButton';
import Table from 'lib/src/components/table/Table';
import { Dispatch, SetStateAction } from 'react';
import { ContactUsMessage } from 'src/types/shared/ContactUsMessages';

const ContactUsMessagesTable: React.FC<ContactUsMessagesTableProps> = ({
    contactUsMessages,
    isFetching,
    setMessageToDelete,
}) => {
    const columns = [
        {
            key: 1,
            heading: 'Name',
            getValue: (row: ContactUsMessage) => `${row.firstName} ${row.lastName}`,
            getSort: (a: ContactUsMessage, b: ContactUsMessage) => {
                try {
                    return a.firstName.localeCompare(b.firstName);
                } catch (e) {
                    return 0;
                }
            },
            searchable: true,
        },
        {
            key: 2,
            heading: 'Email',
            getValue: (row: ContactUsMessage) => row.email,
            searchable: true,
        },
        {
            key: 3,
            heading: 'Date/Time',
            getValue: (row: ContactUsMessage) => dayjs(row.sentOn).format('DD/MM/YYYY HH:mm'),
        },
        {
            key: 5,
            heading: '',
            getValue: (row: ContactUsMessage) => {
                return (
                    <ButtonRow alignment="top">
                        <LinkButton
                            color="green"
                            icon="search"
                            href={`/contact-us-messages/${row.id}`}
                        >
                            View
                        </LinkButton>
                        <ActionButton
                            color="red"
                            icon="times"
                            onClick={() => setMessageToDelete(row.id)}
                        >
                            Remove
                        </ActionButton>
                    </ButtonRow>
                );
            },
        },
    ];

    return (
        <Table columns={columns} rows={Object.values(contactUsMessages)} isLoading={isFetching} />
    );
};

interface ContactUsMessagesTableProps {
    contactUsMessages: ContactUsMessage[];
    isFetching: boolean;
    setMessageToDelete: Dispatch<SetStateAction<number | null>>;
}

export default ContactUsMessagesTable;
